/*
 * PDP: Swym の ATW (Add to Wishlist) ボタンを商品タイトル右上へ移動する。
 * ─ Swym は #swym-atw-button-container を .product-form__buttons (購入エリア) 内に
 *   非同期で注入するため、放置すると「カートボタンの下」に薄いボタンとして出る。
 * ─ 本スクリプトで .product__info-wrapper 直下へ移動し、CSS で右上に絶対配置する
 *   (ヘッダー等と同じお気に入りハートアイコンの位置)。
 * ─ Swym は非同期注入 / 再描画するため MutationObserver + 遅延実行で追従する。
 */
(function () {
  'use strict';

  function place() {
    var cont = document.querySelector('#swym-atw-button-container');
    var target = document.querySelector('.product__info-wrapper');
    if (!cont || !target) return;
    // 既に移動済みなら何もしない (無限ループ / 余計な再配置を防ぐ)
    if (cont.parentElement === target) return;
    target.appendChild(cont); // イベントリスナーは保持したまま移動される
    target.classList.add('vtee-has-atw'); // CSS で位置を効かせるフック
  }

  function run() {
    place();
  }

  run();

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.id === 'swym-atw-button-container') ||
            (n.querySelector && n.querySelector('#swym-atw-button-container'))
          ) {
            run();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // 遅延注入の保険
  window.addEventListener('load', run);
  window.setTimeout(run, 1500);
  window.setTimeout(run, 3500);

  /*
   * クリックでお気に入り追加/削除した時に、Swym が PDP ボタンを再描画しない
   * (追加済み表示はリロード後にしか反映されない) 問題への対応。
   * Swym のイベント (addedToWishlist / removedFromWishlist) を購読し、
   * ハートの塗り状態を即時に切り替える。
   * ─ アウトラインと塗りつぶしは同じ path で fill 属性だけが異なる (none ↔ #fff)。
   *   fill を切り替えるだけで、CSS 側 (fill 属性で色を判定) が即座に
   *   グレー枠 ↔ 黒塗り を反映する。
   */
  function currentProductId() {
    try {
      return String(
        (window.ShopifyAnalytics &&
          window.ShopifyAnalytics.meta &&
          window.ShopifyAnalytics.meta.product &&
          window.ShopifyAnalytics.meta.product.id) || ''
      );
    } catch (e) {
      return '';
    }
  }

  // イベントが「今表示中の商品」に対するものかを判定 (取り出せなければ true=更新する)。
  // PDP の #swym-atw-pdp-button は常に現在の商品用なので、他商品(おすすめ等)の
  // 追加で誤ってこのハートを塗らないようにするためのガード。
  function eventMatchesCurrent(e) {
    try {
      var pid = currentProductId();
      if (!pid) return true;
      var s = JSON.stringify(e && (e.detail || e)) || '';
      return s.indexOf(pid) > -1;
    } catch (err) {
      return true;
    }
  }

  function setHeartActive(active, e) {
    if (e && !eventMatchesCurrent(e)) return;
    var path = document.querySelector('#swym-atw-pdp-button svg path');
    if (path) path.setAttribute('fill', active ? '#fff' : 'none');
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    if (!swat || !swat.evtLayer || !swat.JSEvents) return;
    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function (e) {
      setHeartActive(true, e);
    });
    swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function (e) {
      setHeartActive(false, e);
    });
  });
})();
